import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getWecomLoginUrl() {
  return request({
    url: '/auth/wecom/login-url',
    method: 'get'
  })
}

export function getCenters() {
  return request({
    url: '/org/centers',
    method: 'get'
  })
}

export function getOrgTree() {
  return request({
    url: '/org/tree',
    method: 'get'
  })
}

export function getAccessibleOrgTree() {
  return request({
    url: '/org/accessible-tree',
    method: 'get'
  })
}

export function getGroupsByCenter(centerId) {
  return request({
    url: '/org/groupsByCenter',
    method: 'get',
    params: { centerId }
  })
}

export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params
  })
}

export function addUser(data) {
  return request({
    url: '/user/add',
    method: 'post',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/user/delete/${id}`,
    method: 'delete'
  })
}

export function getCampPeriods() {
  return request({
    url: '/camp-period/my-list',
    method: 'get'
  })
}

export function getGroupKpi(params) {
  return request({
    url: '/dashboard/group-kpi',
    method: 'get',
    params
  })
}

export function getTeacherRank(params) {
  return request({
    url: '/dashboard/teacher-rank',
    method: 'get',
    params
  })
}

export function getGroupRank(params) {
  return request({
    url: '/dashboard/group-rank',
    method: 'get',
    params
  })
}

export function getTeachers(params) {
  return request({
    url: '/dashboard/teachers',
    method: 'get',
    params
  })
}

export function getParents(params) {
  return request({
    url: '/dashboard/parents',
    method: 'get',
    params
  })
}

export function getEvents(params) {
  return request({
    url: '/dashboard/events',
    method: 'get',
    params
  })
}

export function getDashboardData(params) {
  return request({
    url: '/api/dashboard',
    method: 'get',
    params
  })
}

// ---- 营期管理 ----

export function addCampPeriod(data) {
  return request({ url: '/camp-period/create', method: 'post', data })
}

export function updateCampPeriod(id, data) {
  return request({ url: `/camp-period/update/${id}`, method: 'put', data })
}

export function getCampPeriodList() {
  return request({ url: '/camp-period/list', method: 'get' })
}

export function getCurrentCampPeriod() {
  return request({ url: '/camp-period/current', method: 'get' })
}

export function deleteCampPeriod(id) {
  return request({ url: `/camp-period/delete/${id}`, method: 'delete' })
}

export function parseCampExcel(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({ url: '/camp-period/parse-excel', method: 'post', data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
}

export function saveCampPeriodData(data) {
  return request({ url: '/camp-period/import', method: 'post', data })
}

export function getImportRecords(params) {
  return request({ url: '/camp-period/import-records', method: 'get', params })
}

export function getCampRecords(params) {
  return request({ url: '/camp-period/records', method: 'get', params })
}

export function getChatLogs(params) {
  return request({ url: '/dashboard/chat-records', method: 'get', params })
}

export function getEventChain(params) {
  return request({ url: '/dashboard/event-chain', method: 'get', params })
}

export function getCallDetail(params) {
  return request({ url: '/dashboard/call-detail', method: 'get', params })
}
